import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../components/common/SvgIcon';
import classnames from 'classnames';

class HeaderLabelComponent extends Component {
  onHeaderClick = (e) => {
    const { headerClick, menuItem } = this.props;
    e.preventDefault();
    headerClick(menuItem, true);
  };

  render() {
    const { menuItem, highlightMenuFlag } = this.props;
    const ariaCurrent = highlightMenuFlag ? 'page' : '';
    return (
      <li
        className={classnames('c-site-nav__item', {
          'c-site-nav__item--is-current': highlightMenuFlag,
        })}
      >
        <button
          className="c-site-nav__link"
          id={menuItem.id}
          name={menuItem.title}
          onClick={this.onHeaderClick}
          aria-current={ariaCurrent}
        >
          {menuItem.className && (
            <SvgIcon
              id={menuItem.className}
              className="c-site-nav__svg"
              width="24px"
              height="24px"
            />
          )}
          <span
            className="c-site-nav__title"
            data-test-id={`menu-item-${menuItem.id}`}
          >
            {menuItem.title}
          </span>
        </button>
      </li>
    );
  }
}

HeaderLabelComponent.propTypes = {
  menuItem: PropTypes.shape({
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
  }),
  headerClick: PropTypes.func.isRequired,
  highlightMenuFlag: PropTypes.bool,
};

export default HeaderLabelComponent;
